const replaceAll = (string, search, replace) => {
  return string.split(search).join(replace)
}

export const reverseFormatMoney = (value) => {
  if (!value) {
    return 0
  }
  if (typeof value === 'number') return value
  value = value.toString()
  value = value.replace('R$ ', '')
  value = replaceAll(value, '.', '')
  value = value.replace(',', '.')

  value = (+value).toFixed(3)

  return +value
}

export const reverseFormatPercent = (value) => {
  if (!value) {
    return 0
  }
  value = value.toString()
  value = replaceAll(value, '.', '')
  value = replaceAll(value, ',', '.')
  value = value.replace('% ', '')

  value = parseFloat(value)

  return value
}
